<div class="input-group">
        <input class="form-control {{status == 'invalid' ? 'ng-invalid' : ''}}" [disabled]="status == 'checking'" [(ngModel)]="value" (ngModelChange)="valueChange.emit($event)" (change)="doCodeCheck()"/>
        <div class="input-group-append">
                <button class="btn btn-{{getCodeStatusColor()}}" [disabled]="status == 'checking'" (click)="doCodeCheck()">
                        <i class="{{getCodeStatusIcon()}}"></i>
                        <span>{{ 'pg-code-checker.verify-code' | locTranslate }}</span>
                </button>
        </div>
</div>